import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { chooseOptionsConstant } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { FAQ } from 'src/app/models/um/organization';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq-modal',
  templateUrl: './faq-modal.component.html',
  styleUrls: ['./faq-modal.component.scss']
})
export class FaqModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  loiOptions = chooseOptionsConstant;
  isautocode: boolean = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  faq: FAQ;
  modules: any[];
  ist: boolean = false;
  eap: boolean = false;
  grants: boolean = false;
  active:boolean = false;
 istDisplayName:string='';
 eapDisplayName:string='';
 grantsDisplayName:string='';

  faqsForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    CODE: new UntypedFormControl(null),
    QUESTION: new UntypedFormControl(null),
    ANSWER: new UntypedFormControl(null),
    IS_FOR_IST: new UntypedFormControl(false),
    IS_FOR_EAP: new UntypedFormControl(false),
    IS_FOR_GRANTS: new UntypedFormControl(false),
    RECORD_STATE:new UntypedFormControl(true)
  });

  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    //debugger
    this.IsAutoCodeConfigured();
    this.faq = new FAQ();
    if (this.Content.content && this.Content.content.id) { // Edit mode
      this.summaryService.getRFIByID('api/faq/getfaqbyid/' + this.Content.content.id).subscribe((result) => {
        this.faq = result;
        this.setForm(result);
        if (this.Content.heading === 'View') {
          setTimeout(() => {
            this.faqsForm.disable({ emitEvent: false });
          }, 100);
        }
      });
    }
    else {
      this.faq = new FAQ();
      this.faq.IS_FOR_IST = false;
      this.faq.IS_FOR_EAP = false;
      this.faq.IS_FOR_GRANTS = false;
      this.faq.RECORD_STATE = true;
      this.setForm(this.faq);
    }
    this.getModules();
  }

  private IsAutoCodeConfigured(): any {
    var featureid = "609";
    var orgid = this.userService.getOrganizationId();
    this.commonservice.isAutocodeConfigured(featureid, orgid).subscribe((result) => {
      if (result == true) {
        this.isautocode = true;
        //this.isautocodeDisabled = "";
      }
      else {
        this.isautocode = false;
        //if (this.Content.heading === 'View' || this.Content.heading === 'Edit')
        //  this.isautocodeDisabled = "disabled";
      }
    });
  }

  save() {
    if (this.validateControls()) {

      if (this.Content.content && this.Content.heading === 'Add') {
        this.summaryService.Insert('api/faq/insert', this.getForm()).subscribe(result => {
          if (result.Status === 0) {

            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'FAQ  ' + this.faqsForm.controls['QUESTION'].value  + '  added Successfully.' } } });
            this.commonservice.SuccessBanner('FAQ ' + this.faqsForm.controls['QUESTION'].value + ' added successfully');

            this.modalRef.close();

          }
          else {
            this.commonservice.ValidationBanner(result.Message);
            //  this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
         //   this.commonservice.ErrorBanner("Error message");
          }
        })

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.Insert('api/faq/update', this.getForm()).subscribe(result => {
          if (result.Status === 0) {
            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'FAQ '+  this.faqsForm.controls['QUESTION'].value +' Updated Successfully.' } } });

            this.modalRef.close();
            this.commonservice.SuccessBanner('FAQ '+  this.faqsForm.controls['QUESTION'].value +' updated successfully' );
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
            // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
            // this.commonservice.ErrorBanner(result.Message);
          }
        })
      }
    }
  }

  setForm(result: FAQ): void {

    this.faqsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),

      QUESTION: new UntypedFormControl(result.QUESTION),
      ANSWER: new UntypedFormControl(result.ANSWER),
      IS_FOR_IST: new UntypedFormControl(result.IS_FOR_IST),
      IS_FOR_EAP: new UntypedFormControl(result.IS_FOR_EAP),
      IS_FOR_GRANTS: new UntypedFormControl(result.IS_FOR_GRANTS),
      RECORD_STATE:new UntypedFormControl(result.RECORD_STATE)
    });
  }

  private getForm(): FAQ {
    const formModel = this.faqsForm.value;
    //debugger;
    let faq = new FAQ();
    faq = {
      ID: formModel.ID || '',
      QUESTION: formModel.QUESTION || '',
      ANSWER: formModel.ANSWER || '',
      IS_FOR_IST: formModel.IS_FOR_IST,
      IS_FOR_EAP: formModel.IS_FOR_EAP,
      IS_FOR_GRANTS: formModel.IS_FOR_GRANTS,
      RECORD_STATE:formModel.RECORD_STATE

    };

    return faq;
  }

  valueChange(module, $event): void {

    switch (module) {
      case "IST":
        this.faqsForm.controls['IS_FOR_IST'].setValue($event);
        this.faq.IS_FOR_IST = $event;
        //if ($event.checked)
        //  this.faqsForm.controls['IS_FOR_IST'].setValue($event.checked);
        //else
        //  this.faqsForm.controls['IS_FOR_IST'].setValue(0);
        break;

      case "EAP":
        this.faqsForm.controls['IS_FOR_EAP'].setValue($event);
        this.faq.IS_FOR_EAP = $event;
        //if ($event.checked)
        //  this.faqsForm.controls['IS_FOR_EAP'].setValue(1);
        //else
        //  this.faqsForm.controls['IS_FOR_EAP'].setValue(0);
        break;
        // case "1":
        //   this.faqsForm.controls['RECORD_STATE'].setValue($event.checked);
        //   this.faq.RECORD_STATE = $event.checked;



      case "GRANTS":
        this.faqsForm.controls['IS_FOR_GRANTS'].setValue($event);
        this.faq.IS_FOR_GRANTS = $event;
break;
        case "ACTIVE":
          this.faqsForm.controls['RECORD_STATE'].setValue($event);
          this.faq.RECORD_STATE = $event;


        //if ($event.checked)
        //  this.faqsForm.controls['IS_FOR_GRANTS'].setValue(1);
        //else
        //  this.faqsForm.controls['IS_FOR_GRANTS'].setValue(0);
        break;
        // case "INACTIVE":
        //   this.faqsForm.controls['RECORD_STATE'].setValue($event);
        //   this.faq.RECORD_STATE = $event;

        // case "Active":
        //   this.faqsForm.controls['RECORD_STATE'].setValue($event.checked);
        //   this.faq.RECORD_STATE = $event.checked;

    }
  }
  
  getModules() {
    //debugger
    this.summaryService.getModuleByOrgId('api/common/getmodulesbyid').subscribe((result) => {
      this.modules = result;
      let len = this.modules.length;
       for (let i = 0; i < len; i++) {
         switch (this.modules[i].CODE) {
           case "IST":
            this.istDisplayName = this.modules[i].NAME;
            this.ist = true;
             break;
           case "EAP":
            this.eapDisplayName = this.modules[i].NAME;
             this.eap = true;
             break;
           case "GRA":
            this.grantsDisplayName = this.modules[i].NAME;
             this.grants = true;
             break;
             // case "Active":
             //   this.active = false;
         }
       }
    });
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.faqsForm.value;

    // if (this.isautocode == false) {
    //   if (formData.CODE === null || formData.CODE === "") {
    //     $("#CODE").addClass("ng-touched ng-invalid validate-error");
    //     $("#CODE").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Code.<br/>";
    //     isValid = false;
    //   } else {
    //     $("#CODE").addClass("ng-untouched ng-valid");
    //     $("#CODE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    // }


    if (formData.QUESTION === null || formData.QUESTION === "" || formData.QUESTION === undefined) {
      $("#QUESTION").addClass("ng-touched ng-invalid validate-error");
      $("#QUESTION").removeClass("ng-untouched ng-valid");
      message += "Please enter Question <br/>";
      isValid = false;
    } else {
      $("#QUESTION").addClass("ng-untouched ng-valid");
      $("#QUESTION").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.ANSWER === null || formData.ANSWER === "" || formData.ANSWER === undefined) {
      $("#ANSWER").addClass("ng-touched ng-invalid validate-error");
      $("#ANSWER").removeClass("ng-untouched ng-valid");
      message += "Please enter Answer<br/>";
      isValid = false;
    } else {
      $("#ANSWER").addClass("ng-untouched ng-valid");
      $("#ANSWER").removeClass("ng-touched ng-invalid validate-error");


    }

    formData.RECORD_STATE = this.faqsForm.controls["RECORD_STATE"].value ? 1 : 0;

    if (this.faq.IS_FOR_IST === false && this.faq.IS_FOR_EAP === false && this.faq.IS_FOR_GRANTS === false) {
      message += "Please select at least one program<br/>";
      isValid = false;
    }

    if (!isValid)
    this.commonservice.ValidationBanner(message);
      // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }



}
